import React, { useState, useRef } from "react";
import { Link } from 'react-router-dom';

import { Helmet } from 'react-helmet';

export const Free_Placement_Calls = () => {
  // State to hold form inputs and file
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contact: '',
    altContact: '',
    qualification: '',
    stream: '',
    year: '2026',
    experience: 'Fresher',
    courses: '',
    resume: null,
    date: "",
  });

  const handleResumeChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      resume: e.target.files[0], // store the File object
    }));
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const fileInputRef = useRef(null); // ref for the file input

  // Submit form data to backend
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevents page refresh

    const form = new FormData();

    const formattedDate = new Date(formData.date).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    form.append("name", formData.name);
    form.append("email", formData.email);
    form.append("contact", formData.contact);
    form.append("altContact", formData.altContact);
    form.append("qualification", formData.qualification);
    form.append("stream", formData.stream);
    form.append("year", formData.year);
    form.append("experience", formData.experience);
    form.append("courses", formData.courses);
    form.append("date", formattedDate);
    if (formData.resume) {
      form.append("resume", formData.resume);
    }

    try {
      // const response = await fetch("http://localhost:5002/api/placement", {
        const response = await fetch(`${process.env.REACT_APP_API_BASE}/placement`, {
        method: "POST",
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        //   body: JSON.stringify(formData),
        body: form, // Don't include headers
      });

      const result = await response.json();

      if (response.ok) {
        alert("Placement form submitted!");
        setFormData({
          name: '',
          email: '',
          contact: '',
          altContact: '',
          qualification: '',
          stream: '',
          year: '',
          experience: '',
          courses: '',
          resume: null,
          date: "",
        });

        // Clear the file input manually
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else {
        alert(result.error || "Failed to submit placement form");
      }
    } catch (err) {
      console.error(err);
      alert("Error submitting placement form");
    }
  };

  return (
    <>
        <Helmet>
                <title>Fortune Cloud Technologies | Free Placement Calls</title>
                <meta name="description" content="Explore courses and training programs at Fortune Cloud Technologies. Learn with experts and get placed." />
                <meta name="robots" content="index, follow" />
        </Helmet>
      <style>{`
        .page-container {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }
        nav a {
          color: black;
          margin: 0 10px;
          text-decoration: none;
        }
        nav a:hover {
          text-decoration: underline;
        }
        main {
          flex-grow: 1;
          display: flex;
          justify-content: center;
          padding: 30px 15px;
        }
        .form-box {
          background: #f9f9f9;
          padding: 40px;
          border-radius: 15px;
          width: 100%;
          max-width: 700px;
          box-shadow: 0 0 15px rgba(0,0,0,0.1);
          border: 2px solid #102082;
        }
        .form-title {
          font-size: 1.8rem;
          font-weight: bold;
          text-align: center;
          margin-bottom: 30px;
        }
        .form-row {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-bottom: 20px;
        }
        .form-group {
          display: flex;
          flex-direction: column;
          width: 100%;
          margin-bottom: 20px;
        }
        .form-group.half {
          width: 48%;
        }
        label {
          font-weight: 600;
          margin-bottom: 5px;
        }
        @media (max-width: 768px) {
          .form-group.half {
            width: 100%;
          }
        }
      `}</style>

      <div className="page-container myfont1">
        <header className="py-2">
          <Link className="navbar-brand text-center" to="/">
            <img src="/assets/images/fctlogo.png" alt="Logo" width="140" className="img-fluid" />
          </Link>
          <nav>
            <Link to="/" className="fw-bold">Home</Link> / 
            <Link to="/About-Us" className="fw-bold">About</Link> / 
            <Link to="/Contact" className="fw-bold">Contact</Link>
          </nav>
        </header>

        <main>
          <form className="form-box" onSubmit={handleSubmit}>

            <div className="form-title">Free Placement Form</div><hr/>

            <div className="form-group">
              <label htmlFor="name">Full Name <span className="text-danger">*</span></label>
              <input type="text" id="name" name="name" placeholder="Enter your name" className="form-control rounded-0" required value={formData.name} onChange={handleChange} pattern="[a-zA-Z\s]{5,50}"/>
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address <span className="text-danger">*</span></label>
              <input
                type="email" id="email" name="email" placeholder="Enter your email" className="form-control rounded-0" required value={formData.email} onChange={handleChange}
              />
            </div>

            <div className="form-row">
              <div className="form-group half">
                <label htmlFor="contact">Contact Number <span className="text-danger">*</span></label>
                <input
                  type="tel"
                  id="contact" name="contact"
                  placeholder="Primary contact number"
                  className="form-control rounded-0"
                  required
                  value={formData.contact}
                  onChange={handleChange}
                  pattern="[0-9]{10}"
                />
              </div>
              <div className="form-group half">
                <label htmlFor="altContact">Alternate Contact</label>
                <input
                  type="tel"
                  id="altContact" name="altContact"
                  placeholder="Alternate contact number"
                  className="form-control rounded-0"
                  value={formData.altContact}
                  onChange={handleChange}
                  pattern="[0-9]{10}"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group half">
                <label htmlFor="qualification">Qualification <span className="text-danger">*</span></label>
                <select
                  id="qualification" name="qualification"
                  className="form-control rounded-0"
                  required
                  value={formData.qualification}
                  onChange={handleChange}
                >
                  <option value="" disabled>Select Qualification</option>
                  <option value="BE/BTech">BE / BTech</option>
                  <option value="MCA">MCA</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="form-group half">
                <label htmlFor="stream">Stream <span className="text-danger">*</span></label>
                <select
                  id="stream" name="stream"
                  className="form-control rounded-0"
                  required
                  value={formData.stream}
                  onChange={handleChange}
                >
                  <option value="" disabled>Select Stream</option>
                  <option value="Computers / IT">Computers / IT</option>
                  <option value="Electronics">Electronics</option>
                  <option value="Mechanical">Mechanical</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group half">
                <label htmlFor="year">Passout Year <span className="text-danger">*</span></label>
                <select
                  id="year" name="year"
                  className="form-control rounded-0"
                  required
                  value={formData.year}
                  onChange={handleChange} defaultValue="2026"
                >
                  <option value="2026">2026</option>
                  <option value="2025">2025</option>
                  <option value="2024">2024</option>
                  <option value="2023">2023</option>
                  <option value="2022">2022</option>
                </select>
              </div>
              <div className="form-group half">
                <label htmlFor="experience">Experience <span className="text-danger">*</span></label>
                <select
                  id="experience" name="experience"
                  className="form-control rounded-0"
                  required
                  value={formData.experience}
                  onChange={handleChange} defaultValue="Fresher" 
                >
                  <option value="Fresher">Fresher</option>
                  <option value="1 Year">1 Year</option>
                  <option value="2 Year">2 Year</option>
                  <option value="3 + Year">3 + Year</option>
                  <option value="Other">Others</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="courses">Course / Certification Details <span className="text-danger">*</span></label>
              <p>(Mention if any course/Certification done, If Yes, mention course name & Institute Name:
                e.g. JAVA - XXX Technologies or Mention NO)</p>
              <textarea
                id="courses" name="courses"
                placeholder="List your certifications or courses"
                className="form-control rounded-0"
                required
                value={formData.courses}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="resume">Upload Resume <span className="text-danger">*</span></label>
              <input
                type="file"
                id="resume" name="resume"
                accept=".pdf,.doc,.docx"
                className="form-control rounded-0"
                required
                onChange={handleResumeChange}
                ref={fileInputRef}
              />
            </div>

            <button type="submit" className="btn btn-warning w-100">Submit</button>
          </form>
        </main>
      </div>
    </>
  );
};
